export default "__VITE_ASSET__y9Z7L6gx__"